jQuery(function ($) {
    $(document).on('click', '.open-cookie-consent-bar', function (e) {
        e.preventDefault();
        $('#cookie-consent-bar').addClass('cookie-consent-bar-visible');
    });
});
